import { Controller } from "stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["datepicker", "hiddenInput", "addButton", "selectedDates"]

  connect() {
    this.selectedDateTimes = []

    const options = {
      mode: "multiple",
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      minuteIncrement: this.element.dataset.fullHour === "false" ? 1 : 60,
      hourIncrement: 1,
      defaultMinute: 0,
      clickOpens: false,
      positionElement: this.addButtonTarget,
      onClose: this.dateSelected.bind(this),
    }

    this.fp = flatpickr(this.addButtonTarget, options)
  }

  openDatePicker(event) {
    event.preventDefault()
    this.fp.open()
  }

  dateSelected(selectedDates, dateStr, instance) {
    if (selectedDates.length === 0) return

    // In "multiple" mode flatpickr applies the time picker only to the latest clicked date, so apply it to all of them
    const time = instance.latestSelectedDateObj
    selectedDates.forEach(date => {
      date.setHours(time.getHours(), time.getMinutes(), 0, 0)
      if (!this.selectedDateTimes.some(existing => existing.getTime() === date.getTime())) this.selectedDateTimes.push(date)
    })
    this.selectedDateTimes.sort((a, b) => a - b)
    this.updateSelectedDateTimes()
    instance.clear()
  }

  updateSelectedDateTimes() {
    const formattedDatesForSubmission = this.selectedDateTimes.map(date => flatpickr.formatDate(date, "Y-m-d H:i"))
    this.hiddenInputTarget.value = formattedDatesForSubmission.join(',')
    this.renderSelectedDates()
  }

  renderSelectedDates() {
    this.selectedDatesTarget.innerHTML = ''
  
    this.selectedDateTimes.forEach((date, index) => {
      const item = document.createElement('div')
      item.className = 'datetime-item'
      item.textContent = this.formatDateForDisplay(date)

      const removeButton = document.createElement('button')
      removeButton.type = 'button'
      removeButton.textContent = '×'
      removeButton.className = 'btn btn-sm btn-danger ml-2'
      removeButton.addEventListener('click', () => {
        this.selectedDateTimes.splice(index, 1)
        this.updateSelectedDateTimes()
      })

      item.appendChild(removeButton)
      this.selectedDatesTarget.appendChild(item)
    })
  }

  formatDateForDisplay(date) {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }
    return date.toLocaleString('en-US', options)
  }
}
